import { useEffect } from "react";
import classes from "./phonenumber.module.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

/**
 * Phone Number input field
 *
 * @prop label: Label of the input
 * @prop onChange: Function to accept the value of the input
 * @prop value: value of the input
 * 
 * @author Victor Ogunjobi
 * 
 */

const PhoneNumberInput = ({ label, onChange, value, onValidityChange }) => {
  const isValid = value ? isValidPhoneNumber(value) : false;
  
  useEffect(() => {
    onValidityChange?.(isValid);
  }, [isValid, onValidityChange]);

  return (
    <div>
      <label>{label}</label>
      <div className={`input ${classes.phone}`}>
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="NG"
          value={value}
          onChange={onChange}
        />
      </div>
      {value && !isValid && <span className={classes.invalid}>Invalid phone number</span>}
    </div>
  );
};

export default PhoneNumberInput;
